import MojitoServices from 'mojito/services';

import {resolveBackground} from '#core/utils/color-utils.js';
import {icon} from '#core/utils/style-utils.js';

import {BasePalette} from '#core/application/modules/base-palette.js';
import {Betslip} from '#core/application/modules/betting-center/betslip/betslip.js';

import {applicationViewAvantgardeFactory} from './factory/application-view-avantgarde.factory.js';
import {applicationViewCommonFactory} from './factory/application-view-common.factory.js';

const LOCATION = MojitoServices.Promotions.types.LOCATION;

export function applicationViewFactory(PALETTE) {
    return {
        AppViewSportsbook: {
            accaBar: {
                hide: Betslip.isFloating,
            },
            betslipPromotions: {
                locationId: LOCATION.RIGHT,
            },
            style: {
                container: {
                    _desktop_maxWidth: '1440px',
                },
                mainContainer: {
                    ...resolveBackground(PALETTE.APPLICATION_PAGE_BG),
                    fontFamily: BasePalette.palette.FONT_FAMILY,
                    userSelect: 'text',
                    ...PALETTE.APPLICATION_PAGE_TEXT,
                },
            },
            backToTopButtonConfig: {
                button: {
                    style: {
                        base: {
                            whiteSpace: 'nowrap',
                            margin: '80px 0 0 220px',
                            _mobile_margin: '80px 0 0 0',
                            padding: 0,
                            _mobile_padding: 0,
                            ...PALETTE.BACK_TO_TOP_BUTTON.TERTIARY_BUTTON_TEXT,
                        },
                    },
                },
                buttonIcon: icon(PALETTE.BACK_TO_TOP_BUTTON.TERTIARY_BUTTON_ICON_COLOR, 'arrow-up'),
            },
        },
        ...(BasePalette.isAvantgarde() ? applicationViewAvantgardeFactory() : {}),
        ...applicationViewCommonFactory(PALETTE),
    };
}
